import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref } from "vue";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import ConversionChangeHistoryItem from "@/components_v3/statistics/ConversionChangeHistoryItem.vue";
import { getEmployeeConversionEvents } from "@/api/conversions";
import { IConversionChangesHistoryRow } from "@/api/types/conversions-report";
import { PAGINATION_PER_PAGE } from "@/configs/global";
import { ITableHeader, showServerError } from "@/utils";
import { CellsType, prepareItems, RawConfig } from "@/utils/CellsFactory";
import { normalizeConversionHistoryItem } from "@/utils/conversionHistory";

interface Props {
    conversionId: number | string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversionChangeHistory',
  props: {
    conversionId: null
  },
  setup(__props: any) {

const props = __props as {
    conversionId: number | string;
}



const isLoading = ref(true);
const total = ref(0);
const rawItems = ref<IConversionChangesHistoryRow[]>([]);
const offset = ref(0);

const headers: ITableHeader[] = [
    { text: 'Дата события', value: 'event_at', sortable: false, width: '140px' },
    { text: 'ID события', value: 'event_id', sortable: false, align: 'left', width: '80px' },
    { text: 'Тип события', value: 'event_type_label', sortable: false, width: 'auto' },
    { text: 'Старое значение', value: 'old_value', sortable: false, width: 'auto', align: 'right' },
    { text: 'Новое значение', value: 'new_value', sortable: false, width: 'auto', align: 'right' },
];

onBeforeMount(() => {
    updateTable();
});

const changePage = (newOffset: number) => {
    offset.value = newOffset;
    updateTable();
};

const updateTable = async () => {
    isLoading.value = true;
    try {
        const { data, meta } = await getEmployeeConversionEvents(props.conversionId, {
            limit: PAGINATION_PER_PAGE,
            offset: offset.value,
        });
        const rows = data ?? [];
        total.value = meta?.total ?? rows.length;
        rawItems.value = rows.map((row, index) => normalizeConversionHistoryItem(row, index));
        formatItems();
    } catch (err) {
        showServerError(err, 'Ошибка загрузки истории изменений');
    } finally {
        isLoading.value = false;
    }
};

const formattedItems = ref([]);

const cellsConfigs: RawConfig<IConversionChangesHistoryRow> = {
    [CellsType.Date]: {
        event_at: {
            isLine: true,
        },
    },
    [CellsType.Uniq]: {
        old_value: {},
        new_value: {},
    },
    [CellsType.Text]: {
        event_type_label: {},
        event_id: {},
    },
};

const formatItems = () => {
    const columns = headers.map(h => h.value);
    formattedItems.value = prepareItems(rawItems.value, cellsConfigs, columns);
};

return { __sfc: true,props, isLoading, total, rawItems, offset, headers, changePage, updateTable, formattedItems, cellsConfigs, formatItems, BaseTable, ConversionChangeHistoryItem }
}

})